import { render, staticRenderFns } from "./OrderPaymentModal.vue?vue&type=template&id=4e676a6e&scoped=true&"
import script from "./OrderPaymentModal.vue?vue&type=script&lang=js&"
export * from "./OrderPaymentModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderPaymentModal.vue?vue&type=style&index=0&id=4e676a6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e676a6e",
  null
  
)

export default component.exports